import {
  getModule,
  Module,
  MutationAction,
  VuexModule
} from "vuex-module-decorators";
import store from "@/store";
import * as CouponBgImageAPI from "@/api/coupon-bg-image";
import { CommonResponse, isSuccess } from "@/api/response";
import { UploadRequest } from "@/api/coupon-bg-image/request";

const MODULE_NAME = "coupon-bg-image/modify";

/**
 * クーポン背景画像登録更新APIのレスポンスを管理するストアモジュール
 */
@Module({ dynamic: true, store, name: MODULE_NAME, namespaced: true })
class Modify extends VuexModule {
  // state
  commonResponse: CommonResponse = {} as CommonResponse;

  // getters
  get isSuccess() {
    return isSuccess(this.commonResponse);
  }

  get getMessage() {
    return this.commonResponse.message;
  }

  // MutationActions
  @MutationAction
  async upload(uploadRequest: UploadRequest) {
    const commonResponse = await CouponBgImageAPI.upload(uploadRequest);
    return {
      commonResponse
    };
  }

  @MutationAction
  async clearResponse() {
    return {
      commonResponse: {} as CommonResponse
    };
  }
}

export default getModule(Modify);
